<template>
  <a-layout>
    <a-layout-content class="container my-12 px-4">
      <div class="row mb-10 xs:mb-2">
        <div class="w-1/3">
          <img src="@/assets/logo-wheezo-vert.svg" class="xs:h-16" />
        </div>
        <div class="w-2/3 flex justify-end sm:items-baseline xs:hidden">
          <p class="caption sm:mr-4 xs:mt-2">{{ expiryLabel }}</p>
          <a-button @click="confirmLeave">Leave shared history</a-button>
        </div>
        <div class="w-2/3 block text-right sm:hidden">
          <a-button @click="confirmLeave">Leave</a-button>
          <p class="caption xs:mt-2">{{ expiryLabel }}</p>
        </div>
      </div>
      <div class="row -mx-4">
        <div class="w-full lg:w-1/4 p-4 xs:hidden">
          <a-card :bordered="false">
            <h3>What’s this?</h3>
            <p>
              Users of the Respiri wheezo app have the ability to share their asthma history.
            </p>
            <p>
              This is done using a unique one time use 6 digit code that expires within 24 hours of
              creation.
            </p>
          </a-card>
        </div>
        <div class="sm:hidden bg-white text-base p-5 w-screen">
          <div class="flex justify-between items-center">
            <h3 class="mb-0 w-7/12">History</h3>
            <p class="mb-0 w-5/12 text-right">
              <span @click="displayMoreInfo = !displayMoreInfo" class="link">
                <span class="link">What's this?</span>
              </span>
            </p>
          </div>
          <template v-if="displayMoreInfo">
            <p class="mt-6">
              Users of the Respiri wheezo app have the ability to share the history of their
              recordings along with information and log of their preventers, relievers, symptoms and
              triggers.
            </p>
            <p>
              This is done using a unique one time use 6 digit code that expires within 24 hours of
              creation.
            </p>
          </template>
        </div>
        <div class="w-full lg:w-3/4 p-4">
          <RecordingHistory />
          <div class="text-center">
            <a-button
              ghost
              class="mx-auto px-10 mt-10"
              v-if="!isEventListEmpty"
              :disabled="!canLoadMore"
              :loading="isLoadingMore"
              @click="loadMore"
            >
              Load more
            </a-button>
          </div>
        </div>
      </div>
    </a-layout-content>
    <Footer />
  </a-layout>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { LEAVE_SESSION, FETCH_HISTORY, EXPIRY_COUNTDOWN } from '@/store';

// Components
import Footer from '@/components/Footer.vue';
import RecordingHistory from '@/views/dashboard/RecordingHistory.vue';

@Component({
  components: {
    Footer,
    RecordingHistory
  }
})
export default class DashboardPage extends Vue {
  displayMoreInfo = false;
  isLoadingMore = false;

  get isEventListEmpty() {
    return !this.$store.state.events.length;
  }

  get canLoadMore() {
    return this.$store.state.events.length && !!this.$store.state.nextToken;
  }

  get expiryLabel() {
    return this.$store.getters[EXPIRY_COUNTDOWN]
      ? `Expires in ${this.$store.getters[EXPIRY_COUNTDOWN]}`
      : '';
  }

  confirmLeave() {
    const self = this;
    this.$confirm({
      title: 'Are you sure you want to leave?',
      content:
        'You will no longer be able to access this users wheezo history unless another share code is generated.',
      autoFocusButton: null,
      onOk() {
        self.logout();
      },
      cancelButtonProps: { props: { type: 'ghost' } }
    });
  }

  logout() {
    this.$store.dispatch(LEAVE_SESSION);
    this.$router.push({ name: 'home' });
  }

  loadMore() {
    this.isLoadingMore = true;
    this.$store
      .dispatch(FETCH_HISTORY)
      .catch(err => {
        this.$message.error('Failed to retrive recording history');
      })
      .finally(() => {
        this.isLoadingMore = false;
      });
  }
}
</script>
<style lang="postcss" scoped>
.line {
  width: 1px;
  height: 24px;
  background-color: #878f8f;
}
.row {
  @apply flex flex-wrap align-top;
}
.link {
  color: #1976d2;
  cursor: pointer;
}
</style>
